// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_BUYER_buyer_HAS_NOT_READ_YET = "%(buyer)s si je\u0161t\u011b nep\u0159e\u010detla";
export const BZ2_BUYER_buyer_READ_THE_MESSAGE_ON_date = "%(buyer)s si p\u0159e\u010detla %(date)s";
export const BZ2_BUYER_HAS_NOT_READ_YET = "Zat\u00edm nep\u0159e\u010dten\u00e9";
export const BZ2_BUYER_READ_THE_MESSAGE_ON_date = "P\u0159e\u010detla %(date)s";
export const BZ2_SELLER_HAS_NOT_READ_YET = "Zat\u00edm nep\u0159e\u010dten\u00e9";
export const BZ2_SELLER_READ_THE_MESSAGE_ON_date = "P\u0159e\u010detla %(date)s";
export const BZ2_SELLER_seller_HAS_NOT_READ_YET = "%(seller)s si je\u0161t\u011b nep\u0159e\u010detla";
export const BZ2_SELLER_seller_READ_THE_MESSAGE_ON_date = "%(seller)s si p\u0159e\u010detla %(date)s";
